import React, { useEffect, useState } from 'react';
import OftadehLayout from '../../components/OftadehLayout/OftadehLayout';
import { Button, CircularProgress, Grid, makeStyles, Typography } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import { API_URL, BASE_IMG_URL, getDefName, getTypeName } from '../../constants';
import { getLanguageList, getNewsCategoryList, getNewsList, getNewsManagerList } from '../../constants/PromiseHttp';
import swal from '@sweetalert/with-react';
import axiosInstance from '../../constants/AxiosInstance';
import moment from 'moment';
import { useLocation } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  my3: {
    margin: '1.3rem 0',
  },
  mb0: {
    marginBottom: 0,
  },
  mRight: {
    marginRight: '.85rem',
  },
  p1: {
    padding: '.85rem',
  },
}));

const NewsListPage = (props) => {
  const { history } = props;
  const classes = useStyles();

  const location = useLocation();
  const cate = location.pathname.replace('/pages/news/', '');

  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [languages, setLanguages] = useState([]);

  const rowClick = (data) => {
    //console.log(data);
    history.push(`/pages/news/detail?cate=${cate}&type=edit&id=${data[0]}`);
  };

  const rowDelete = (row) => {
    let ids = [];
    row.data.map((r) => {
      ids.push(data[r.dataIndex].id);
      return r;
    });
    let delParam = {
      ids: ids.toString(),
    };
    swal({
      title: 'Are you sure you want to delete?',
      text: '',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        axiosInstance.post(`${API_URL}/news/deleteIds`, delParam, { headers: { Pragma: 'no-cache' } }).then((response) => {
          swal('It is deleted.', {
            icon: 'success',
          });
          getData();
        });
      } else {
        getData();
      }
    });
  };

  const cols = [
    {
      name: 'id',
      label: 'id',
      options: {
        filter: false,
        sort: true,
        display: false,
        viewColumns: false,
      },
    },
    {
      name: 'id',
      label: 'No.',
      options: {
        filter: false,
        sort: true,
        display: true,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return tableMeta.rowIndex + 1;
        },
      },
    },
    {
      name: 'languageId',
      label: 'Language',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const lang = languages.find((lang) => lang.id === value);
          return lang ? lang[getDefName()] : '';
        },
      },
    },
    {
      name: 'categoryId',
      label: 'Category',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const cate = categoryList.find((_cate) => _cate.id === value);
          return cate ? cate[getDefName()] : '';
        },
      },
    },
    {
      name: 'thumbs',
      label: 'Image',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          //console.log(value);
          if (value && value.length > 0) {
            const url = `${BASE_IMG_URL}` + value[0].key;
            return <img src={url} width={30} alt={value[0].name} />;
          } else {
            const mainImg = tableMeta.rowData[tableMeta.columnIndex + 1]
            if(mainImg && mainImg.length > 0) {
              const url = `${BASE_IMG_URL}` + mainImg[0].key;
              return <img src={url} width={30} alt={mainImg[0].name} />;
            } else {
              return '';
            }
          }
        },
      },
    },
    {
      name: 'images',
      label: 'Main',
      options: {
        filter: false,
        sort: true,
        display: false,
      },
    },
    {
      name: 'title',
      label: 'Title',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'hidden',
      label: 'Show/Hide',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? 'Hide' : 'Show';
        },
      },
    },
    {
      name: 'createdAt',
      label: 'Registration Date',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return moment(Number(value)).format('YYYY-MM-DD HH:mm');
        },
      },
    },
    {
      name: 'viewCnt',
      label: 'View Count',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value || 0;
        },
      },
    },
  ];

  const options = {
    print: false,
    filter: false,
    filterType: 'checkbox',
    selectableRows: 'multiple',
    viewColumns: false,
    download: false,
    onRowClick: rowClick,
    onRowsDelete: rowDelete,
  };

  useEffect(() => {
    getLanguageList().then((result) => {
      setLanguages(result);
    });
    getNewsCategoryList().then((result) => {
      setCategoryList(result);
    });
    getData();
  }, []);

  const getData = () => {
    setLoading(true);
    if (sessionStorage.getItem('bt_role') === 'SYS_MGR') {
      getNewsManagerList(cate, sessionStorage.getItem('bt_user')).then((result) => {
        setLoading(false);
        setData(result);
      });
    } else {
      getNewsList(cate).then((result) => {
        setLoading(false);
        setData(result);
      });
    }
  };

  const getTitle = () => {
    const ct = categoryList.find((_cate) => _cate.id === cate);
    return ct ? ct[getDefName()] : '';
  }

  return (
    <OftadehLayout>
      <Grid container className={classes.my3} alignItems="center">
        <Grid item className={classes.mRight} style={{ fontWeight: 'bold' }}>
          <Typography variant="h5" component="h1" style={{ fontWeight: 'bold' }}>
            {`New & Column List (${getTitle()})`}
          </Typography>
        </Grid>
        <Grid item>
          <Button onClick={() => history.push('/pages/news/edit?type=new')} variant="outlined" color="primary" size="small">
            Registration
          </Button>
        </Grid>
      </Grid>
      {/*<OftadehBreadcrumbs path={history} />*/}
      <MUIDataTable title={''} data={data} columns={cols} options={options} />
      {loading && (
        <div style={{ position: 'fixed', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', zIndex: 999 }}>
          <CircularProgress color={'secondary'} />
        </div>
      )}
    </OftadehLayout>
  );
};

export default NewsListPage;
